/**
 * 플레이 시간 추적 시스템
 */

import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';

export const playTimeSystem: TickSystem<GameState, GameAction> = {
  name: 'playTime',

  update(state, deltaTime) {
    if (!state.isRunning) return state;

    const deltaSeconds = deltaTime / 1000;

    return {
      ...state,
      statistics: {
        ...state.statistics,
        playTime: state.statistics.playTime + deltaSeconds
      }
    };
  }
};
